module.exports = __webpack_public_path__ + "static/img/lock.1d84918.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/lock.png
// module id = v3L/
// module chunks = 1